import * as React from "react";
import AuthService from "../../Components/auth/AuthService";
import Autocomplete from '@mui/material/Autocomplete';
import { Box } from "@mui/system";
import Stack from '@mui/material/Stack';
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router";
import { useLoadingDispatch, showLoading, hideLoading } from '../../context/loadingContext';
import { locationTypes, yesNo } from "../../Components/common/Constants";
import { Button, Row, Col, Input, Select, message, Descriptions, Tag, Flex, Table, Tooltip, Modal, Divider } from "antd";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import moment from "moment";
import { decodeId, formatCurrency } from "../../Components/common/CommonFun";
import { netsuite_url } from "../../Components/config";
import { ArrowLeftOutlined, CalendarOutlined, EyeFilled, EyeInvisibleFilled, EyeOutlined, FileDoneOutlined, InfoCircleOutlined, TableOutlined } from "@ant-design/icons";
import { set } from "lodash";
import { showMessage } from "../../Components/Utils/message";
import InfoCards from "../../Components/InfoCards";
import DetailsGrid from "../../Components/common/DetailsGrid";
import dayjs from "dayjs";

const Auth = new AuthService();

export default function TransactionsPurchaseOrder(props) {

  const navigate = useNavigate();
  const params = useParams();
    const decodedID = decodeId(params?.id)

  const { Option } = Select
  var layoutDispatch = useLoadingDispatch();
  const dispatch = useDispatch()
  const { products, locations, roles } = useSelector((state) => state?.AppState?.userCreds);
  const hasRole5 = roles?.some(r => r.role_id === 5);
  

  const [id, setId] = React.useState(decodedID ? decodedID : 0);
  const [order, setOrder] = React.useState([]);
  const [productDetail, setProductDetails] = React.useState([]);
  const [modalOpen, setModalOpen] = React.useState(false);
  const [selectedProduct, setSelectedProduct] = React.useState('');

  const getDataByID = async () => {
    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch(`/stock/purchase-order-details?id=${id}`);
      if (res.ack) {
        setOrder(res?.purchase_order)
      } else {
        setOrder([])
        showMessage('error', res?.message)
      }
    } catch (error) {
      showMessage('error',"Something went wrong");
    } finally {
      hideLoading(layoutDispatch);
    }

  };

  const getProductDetails = async (record) => {
    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch(`/stock/purchase-order-product-details?product_netsuite_id=${record?.product_netsuite_id}&purchase_order_id=${id}`);
      if (res.ack) {
        const filteredBatches = res?.purchase_order_product_details.filter((item)=> item.batch_code != null)
        console.log('filteredBatches', filteredBatches);
        
        if(filteredBatches.length > 0) {
          setProductDetails(filteredBatches)
          const item = products?.find((item) => item.netsuite_id == record?.product_netsuite_id);
          setSelectedProduct(item)
          setModalOpen(true);
        } else {
          showMessage('error', 'No details found for this product')
        }
      } else {
        setProductDetails([]);
        setSelectedProduct('')
        showMessage('error', res?.message)
      }
    } catch (error) {
      showMessage('error',"Something went wrong");
    } finally {
      hideLoading(layoutDispatch);
    }
  }

  React.useEffect(() => {
    if (id > 0) {
      getDataByID()
    }


  }, []);

  const dataCol = [
    
    {
      title: "Product",
      render(record) {
        const item = products?.find((item) => item.netsuite_id == record?.product_netsuite_id);

        return (
          <span>{item ? `${item?.code} - ${item?.name}` : '-'}</span>
        )

      }
    },
    // {
    //   title: "Category",
    //   render(record) {
    //     const item = products?.find((item) => item.netsuite_id == record?.product_netsuite_id);

    //     return (
    //       <span>{item ? `${item?.category}` : '-'}</span>
    //     )

    //   }
    // },
    {
      title: "Category",
      render(record) {
        const item = products?.find((item) => item.netsuite_id == record?.product_netsuite_id);

        return (
          <span>{item ? `${item?.sub_category}` : '-'}</span>
        )

      }
    },
    {
      title: 'Order Qty',
      render: (record) => {
        return  <Tag color='blue' style={{ fontSize: 16, fontWeight: 'bold' }}>{Number(record?.quantity)?.toLocaleString() || 0} </Tag>
        ;
      },
    },
    {
      title: 'Received Qty',
      render: (record) => {
        return <Tag color='green' style={{ fontSize: 16, fontWeight: 'bold' }}>{Number(record?.received_quantity)?.toLocaleString() || 0} </Tag>
        ;
      },
    },
    {
      title: 'Unit',
      render: (record) => {
        return (
          <>
            <span>{formatCurrency(record.unit_price) || ''}</span>
          </>
        )
      },
      width: 100
    },
    {
      title: 'Action',
      key: 'action',
      align: 'right',
      render: (text, record) => (
        <div>

          <EyeOutlined
            style={{
              fontSize: "25px",
              cursor: "pointer",
              marginRight: "5px",
              color: "#006cb8",
            }}
            onClick={() => getProductDetails(record)}
          />
        </div>
      )
    },

  ];

  const productDetailsCol = [
   
      // {
      //   title: "Product",
      //   render(record) {
      //     const item = products?.find((item) => item.netsuite_id == record?.product_netsuite_id);
  
      //     return (
      //       <span>{item ? `${item?.code} - ${item?.name}` : '-'}</span>
      //     )
      //   }
      // },
      {
        title: "Batch Code",
        render(record) {
          return (
            <span>{record?.batch_code || '-'}</span>
          )
        }
      },
      {
        title: "Supplier Batch Code",
        render(record) {
          return (
            <span>{record?.supplier_batch_code || '-'}</span>
          )
        }
      },
      {
        title: 'Quantity',
        render: (record) => {
          return  <Tag color='green' style={{ fontSize: 16, fontWeight: 'bold' }}>{record?.batch_quantity} </Tag>
        },
      },
      {
              title: "Expiry",
              render: (record) => {
                const expiry = record?.expiry_date;
                if (!expiry) return "";
        
                const expiryDate = dayjs(expiry, "YYYY-MM-DD");
                const today = dayjs();
                const diffDays = expiryDate.diff(today, "day");
        
                let color = "green";
                if (diffDays < 0) {
                  color = "red";
                } else if (diffDays <= 7) {
                  color = "orange";
                }
        
                return <Tag style={{ fontSize: '15px' }} color={color}>{dayjs(expiry).format('DD-MM-YYYY')}</Tag>;
              }
            },
      {
  title: "User",
  render(record) {
    if (!record) return "";

    const user = record?.user_name || "";
    const helper = record?.helper_name || "";

    if (helper) {
      return (
        <>
          {helper}{" "}
          {user && (
            <Tooltip title={`${user}`}>
              <InfoCircleOutlined style={{ fontSize: 16, marginLeft: 6, color: "#1890ff" }} />
            </Tooltip>
          )}
        </>
      );
    }

    return <>{user}</>;
  }
},
      {
        title: 'Created At',
        render: (record) => {
          return <span>{record?.createdAt ? moment(record?.createdAt).format("DD-MM-YYYY HH:MM:ss") : ""}</span>;
        },
      },
      
    
  ]
  
const infoItems = [
    {
      label: "PO No.",
      type: 'link',
      icon: <FileDoneOutlined  style={{ color: "#1677ff" }}/>,
      value: order[0]?.po_number ? (
        <>
        {
          hasRole5 ? (
            <>{order[0]?.po_number}</>
          ) : (
            <Tooltip title="View Purchase Order" placement="top">
          <a
            href={`${netsuite_url}/app/accounting/transactions/purchord.nl?id=${order[0]?.internal_id}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#2563eb", fontWeight: 600 }}
          >
            {order[0]?.po_number}
          </a>
        </Tooltip>
          )
        }
        </>
        
      ) : (
        "-"
      ),
    },
    {
      label: "Receipt No.",
      type: 'link',
      icon: <TableOutlined style={{color: "#a0d911"}}/>, 
      value: order[0]?.receipt_code ? (
        <>
        {
          hasRole5 ? (
            <>{order[0]?.receipt_code}</>
          ) : (
            <Tooltip title="View Receipt" placement="top">
          <a
            href={`${netsuite_url}/app/accounting/transactions/itemrcpt.nl?id=${order[0]?.receipt_id}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#2563eb", fontWeight: 600 }}
          >
            {order[0]?.receipt_code}
          </a>
        </Tooltip>
          )
        }
        </>
        
      ) : (
        "-"
      ),
    },
    {
      label: "Received Date",
      type: 'text',
      icon: <CalendarOutlined style={{ color: "#fa541c" }} />,
      value: order[0]?.received_date
        ? moment(order[0]?.received_date).format("DD-MM-YYYY")
        : "-",
    },
    {
      label: "Posting Date",
      type: 'text',
      icon: <CalendarOutlined style={{ color: "#fa541c" }} />,
      value: order[0]?.posting_date
        ? moment(order[0]?.posting_date).format("DD-MM-YYYY")
        : "-",
    },
  ];
  return (
    <div>
      <Flex justify="space-between" align="center">
        <h3>Purchase Order Details</h3>
        <Button
          onClick={() => navigate(`/transaction-po`)}
          style={{ marginRight: "10px" }}
          icon={<ArrowLeftOutlined />}
        >
          Back
        </Button>
      </Flex>
      {/* <InfoCards items={infoItems} /> */}
      <DetailsGrid  infoItems={infoItems}  />
      <Table
        dataSource={order}
        pagination={false}
        columns={dataCol}
        scroll={{ x: "max-content" }}
        rowClassName={(_, index) => (index % 2 === 1 ? "table-row-striped" : "")}
      />

      <Modal
        title={selectedProduct ? `Received Batches: ${selectedProduct?.code} - ${selectedProduct?.name}` : 'Product Details'}
        open={modalOpen}
        onCancel={() => setModalOpen(false)}
        width={1000}
        footer={null}
      >
        <>
        <Divider />
        <Table 
        dataSource={productDetail}
        pagination={false}
        columns={productDetailsCol}
        scroll={{ x: "max-content" }}
        rowClassName={(_, index) => (index % 2 === 1 ? "table-row-striped" : "")}
        />
        </>
        

      </Modal>
    </div>
  );
}

